import { Check } from "@material-ui/icons";
import React, { useState } from "react"
import CopyIcon from "./CopyIcon";

const CopyButton = ({ text }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <div className="flex items-center justify-start p-4 bg-gray-50 rounded-md mt-4">
      <span className="font-mono text-gray-700">{text}</span>
      <button
        onClick={handleCopy}
        className="ml-4 p-2 text-gray-600 hover:text-gray-900 rounded-md hover:bg-gray-200 transition-colors"
        aria-label="Copy app ID"
      >
        {copied ? (
          <Check className="w-5 h-5 text-green-600" />
        ) : (
          <CopyIcon className="-ml-0" />
        )}
      </button>
    </div>
  )
}

export default CopyButton